import { buildCustomTypeDirectoryPath } from "./buildCustomTypeDirectoryPath.js";
import { deleteProjectFile } from "./deleteProjectFile.js";
const deleteCustomTypeDirectory = async (args) => {
  const dir = buildCustomTypeDirectoryPath(args);
  const relativeDir = buildCustomTypeDirectoryPath({
    ...args,
    absolute: false
  });
  await deleteProjectFile({
    filename: relativeDir,
    helpers: args.helpers
  });
  return dir;
};
export {
  deleteCustomTypeDirectory
};
//# sourceMappingURL=deleteCustomTypeDirectory.js.map
